<template>
    <ExitIntent v-if="showIntent" :timeoutSeconds="15">
        <!-- Since modal gets teleported outside of the scope, additional v-if is needed to close it-->
        <!-- width 800px to fit the button not wrapped-->
        <NewsletterModal v-if="showModal" show-close :width="840" @close:newsletter="closeModal">
            <div class="newsletter newsletter-intent">
                <div class="row no-gutters">
                    <div class="col-12 col-lg-5">
                        <ImageFluid
                            :src="require('@/assets/newsletter/bg_newsletter_intent.jpg')"
                            alt="Newsletter-Bild"
                            class="newsletter-intent__image"
                            width="1000"
                            height="667"
                        />
                    </div>

                    <div class="col-12 col-lg-7 text-center">
                        <div class="px-4 py-3">
                            <h3 class="mb-3 mb-lg-4 newsletter-title">{{ $t('Newsletter.intent.header') }}</h3>

                            <p class="mb-3 mb-lg-4 px-lg-5"></p>
                            <translate path="Newsletter.intent.beforeLeaveText" tag="p">
                                <template #break>
                                    <br />
                                </template>
                                <template #discount> {{newsletterDiscountInEuro}} </template>
                            </translate>
                            <p class="mb-3 mb-lg-4 px-lg-5">{{ $t('Newsletter.intent.registerNowText') }}</p>

                            <NewsletterForm source="ExitIntent" />
                        </div>
                    </div>
                </div>
            </div>
        </NewsletterModal>
    </ExitIntent>
</template>

<script>
import ExitIntent from '@/components/utility/ExitIntent';
import Modal from '@/components/Modal';
import NewsletterForm from '@/components/newsletter/NewsletterForm';
import NewsletterModal from '@/components/modals/NewsletterModal';
import ImageFluid from '@/components/ImageFluid';

const LOCAL_STORAGE_KEY = 'exit-intent-newsletter';

export default {
    name: 'ExitIntentNewsletter',
    components: { ImageFluid, NewsletterModal, NewsletterForm, Modal, ExitIntent },
    data() {
        return {
            showIntent: false,
            showModal: true
        };
    },
    computed: {
        subscribedToNewsletter() {
            return this.$store.getters.referredByNewsletter;
        },
        newsletterEnabled() {
            return this.$store.state.globalMeta.newsletterFormEnabled;
        },
        newsletterDiscountInEuro() {
            return this.$store.state.globalMeta.newsletterDiscount / 100;
        }
    },
    methods: {
        async closeModal() {
            localStorage.setItem(LOCAL_STORAGE_KEY, 'no');
            this.showModal = false;
            await this.$nextTick();
            this.showIntent = false;
        }
    },
    mounted() {
        const navigatedFromShop = this.$nuxt.context.from;
        this.showIntent =
            localStorage.getItem(LOCAL_STORAGE_KEY) !== 'no' &&
            !this.subscribedToNewsletter &&
            this.newsletterEnabled &&
            navigatedFromShop;
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';
@use '@/styles/bootstrap/breakpoints' as breakpoints;

.modal {
    ::v-deep {
        .modal-body {
            padding: 0 !important;
        }
    }
}

.newsletter-intent {
    display: flex;
    background: hsl(0, 0%, 100%);

    h3 {
        color: variables.$primary;
        text-decoration: underline;
        font-weight: bold;
    }

    p {
        font-weight: bold;
        font-size: 18px;
        color: rgb(153, 153, 153);
    }

    @include breakpoints.media-breakpoint-up(variables.$desktop-breakpoint-min) {
        &__image ::v-deep .img-fluid {
            object-position: -70px center;
        }
    }

    &__close {
        position: absolute;
        top: -15px;
        right: -15px;
        border-radius: 50%;
        width: 31px;
        height: 30px;
        display: flex;
        border: none;
        justify-content: center;
        align-items: center;
        background-color: hsla(0, 0%, 0%, 0.75);
        color: variables.$muted;
        box-shadow: 5px 5px 10px 0 hsla(0, 0%, 0%, 0.25);
        z-index: 3;
        padding: 0;
    }
}
</style>
